import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa'; // Import the left arrow icon

function Tabs() {
  const tabClass =
    'px-6 py-2 text-base font-medium border-b-2 border-transparent hover:border-black transition-all ';
  const activeClass = ' text-white bg-black';

  return (
    <div className="mb-4">
      {/* Back arrow with link to '/dashboard/users' */}
      <NavLink
        to="/dashboard/mdm/users"
        className="flex items-center text-gray-400 hover:text-black mb-4"
      >
        <FaArrowLeft className="mr-3 text-md" /> {/* Left arrow icon */}
        <span className="text-lg">Back to Users</span>
      </NavLink>

      {/* Tabs container */}
      <div className="flex  border-b">
        <NavLink
          to="/dashboard/mdm/users/manage-roles"
          className={({ isActive }) =>
            `${tabClass} ${isActive ? activeClass : 'text-black bg-white'}`
          }
        >
          Manage Roles
        </NavLink>
        <NavLink
          to="/dashboard/mdm/users/manage-permissions"
          className={({ isActive }) =>
            `${tabClass} ${isActive ? activeClass : 'text-black bg-white'}`
          }
        >
          Manage Permissions
        </NavLink>
      </div>
    </div>
  );
}

export default Tabs;
